
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("aSvPN", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $7eb7a42a13728d8b$export$2cd8252107eb640b; });
// ====================================================================================
// panels.module
// ====================================================================================

var $jG4hL = parcelRequire("jG4hL");
const $7eb7a42a13728d8b$export$2cd8252107eb640b = ()=>{
    let attempts = 0;
    // if document.ready needed
    const whenComplete = ()=>{
        if (attempts > 30) return;
        attempts += 1;
        if (document.readyState === "complete") {
            const collapseHandler = (selector)=>{
                let targets = Array.from(document.querySelectorAll(selector));
                targets.forEach((elem)=>{
                    (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).slideToggle(500).toggleClass("show");
                    let shown = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).hasClass("show");
                    let panelBtn = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).prev();
                    if (shown) {
                        panelBtn.children("button").attr("aria-expanded", "true");
                        panelBtn.addClass("panel__btn--open");
                    } else {
                        panelBtn.children("button").attr("aria-expanded", "false");
                        panelBtn.removeClass("panel__btn--open");
                    }
                });
            };
            (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))("section .panel").on("click", function(ev) {
                let elem = ev.target;
                let parent = (0, (/*@__PURE__*/$parcel$interopDefault($jG4hL)))(elem).closest(".panel__btn");
                if (parent.length) {
                    let target = parent.find("button[data-target]").data("target");
                    collapseHandler(target);
                }
            });
        } else setTimeout(function() {
            whenComplete();
        }, 400);
    };
    whenComplete();
};

});


//# sourceMappingURL=panels.module.9ec97b76.js.map
